import React from "react";
import { Link } from "react-router-dom";
import seFormer from "../assets/images/se-former.png";
import useMobile from "../Hook/UseMobile";
import { FaChevronRight } from "react-icons/fa6";

function SeFormer() {
	const isMobile = useMobile();

	return (
		<div className="atelier" id="seFormer">
			<div className="former__img-container">
				<img className="atelier__img" src={seFormer} alt="" />
			</div>
			<div className="former__text-container">
				<h2 className="atelier__title">
					Se{" "}
					<strong>
						<i>former</i>
					</strong>
				</h2>
				<p className="atelier__text">
					#changerlesregles ça commence aussi par se former à mieux comprendre les enjeux et conséquences des règles et à mettre des projets en place dans sa structure ! C’est pour cela que nous intervenons auprès des relais éducatifs de tout horizon (enseignants, membre de l'équipe éducative scolaire, éducateur.ices spécialisés,...).
				</p>
				<p className="atelier__text">
					Notre formation d'une journée "Changer les règles dès le plus jeune âge" est organisée au sein des structures accompagnant des jeunes et qui souhaitent mettre en place un projet autour des règles et/ou être mieux outillées pour répondre aux questions et prévenir la précarité menstruelle dans leur accompagnement quotidien du public menstrué accueilli.
				</p>
				<p className="atelier__text">
					Nous vous invitons à envoyer un mail sur l'adresse <b><a href="mailto:formation@regleselementaires.com">formation@regleselementaires.com</a></b> pour planifier une formation.
				</p>
				{!isMobile && (
					<Link to="https://doccollectes.blob.core.windows.net/formations/Programme%20de%20formation%20relais%20e%cc%81ducatifs.pdf" className="atelier__button focused" target="_blank" rel="noreferrer">
						Programme de la formation{" "}
						<FaChevronRight className="partners-footer__chevron" />
					</Link>
				)}
			</div>
			{isMobile && (
				<Link to="https://doccollectes.blob.core.windows.net/formations/Programme%20de%20formation%20relais%20e%cc%81ducatifs.pdf" className="atelier__button">
					Programme de la formation{" "}
					<FaChevronRight className="partners-footer__chevron" />
				</Link>
			)}
		</div>
	);
}

export default SeFormer;
